import { render, staticRenderFns } from "./carNums.vue?vue&type=template&id=dbe6f9a2&scoped=true&"
import script from "./carNums.vue?vue&type=script&lang=js&"
export * from "./carNums.vue?vue&type=script&lang=js&"
import style0 from "./carNums.vue?vue&type=style&index=0&id=dbe6f9a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe6f9a2",
  null
  
)

export default component.exports